var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22948 11.117C3.87851 9.84401 5.20178 8.9722 6.72868 8.9722C8.24379 8.9722 9.55838 9.83061 10.2127 11.0876L3.22948 11.117ZM8.0371 5.85685C8.0371 6.61393 7.4234 7.22763 6.66638 7.22763C5.90935 7.22763 5.29563 6.61393 5.29563 5.85685C5.29563 5.09984 5.90935 4.48613 6.66638 4.48613C7.4234 4.48613 8.0371 5.09984 8.0371 5.85685ZM6.72868 12.3368C3.63169 12.3368 1.12109 9.82612 1.12109 6.72917C1.12109 3.63218 3.63169 1.12158 6.72868 1.12158C9.82564 1.12158 12.3363 3.63218 12.3363 6.72917C12.3363 9.82612 9.82564 12.3368 6.72868 12.3368Z",
    stroke: "black",
    strokeOpacity: 0.95,
    strokeWidth: 1.12152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.94851db4e3b3424e9764321b1b772211.svg";
export { ForwardRef as ReactComponent };